<template>
  <div :class="{'swiper-container': isBadgeClass}" :id="swiperId">
    <ul :class="{'p-learning-badge swiper-wrapper':isBadgeClass, 'p-top-missionList': isMissionClass}">
      <slot></slot>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";

  const isMissionClass = ref(false) // TOP画面から来たかによってスタイル適用
  const isBadgeClass = ref(false) // 教科別学習状況画面から来たかよってスタイル適用

  const props = defineProps<{
    swiperIdBadge?: string;
    swiperIdMission?: string;
  }>()

  const swiperId = computed(() => {
    if (props.swiperIdBadge) {
      isBadgeClass.value = true
      return props.swiperIdBadge
    }
    if (props.swiperIdMission) {
      isMissionClass.value = true
      return "mission_" + props.swiperIdMission
    }
  })
</script>